import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const bonuses = [{
  emoji: '🗓️',
  title: 'BONO 1 — HOJA DE RUTA: DE 0 A TU PRIMERA IMPLEMENTACIÓN EN 7 DÍAS',
  desc: 'Un plan paso a paso para organizar, aplicar y lanzar el sistema durante una semana.',
  value: '$8.990'
}, {
  emoji: '🖥️',
  title: 'BONO 2 — PLANTILLA LANDING PAGE DE CONVERSIÓN',
  desc: 'La estructura de una landing pensada para presentar tu producto o servicio de forma más clara y persuasiva.',
  value: '$8.990'
}, {
  emoji: '📊',
  title: 'BONO 3 — CALCULADORA DE RENTABILIDAD',
  desc: 'Herramientas para calcular inversión, margen, retorno y tomar decisiones con más criterio.',
  value: '$7.990'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-20 px-4 bg-gradient-to-b from-green-950/40 via-green-950/40 to-[#0a1628]/80" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 5
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10px'
      }} transition={{
        duration: 0.2
      }} className="text-center mb-8 sm:mb-16" data-id="element-23">
          <span className="text-5xl mb-2 sm:mb-4 block" data-id="element-24">🎁</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4 drop-shadow-lg uppercase" data-id="element-25">
            BONUS EXCLUSIVOS INCLUIDOS
          </h2>
          <p className="text-2xl text-yellow-300 font-bold" data-id="element-26">
            GRATIS CON TU COMPRA DE HOY
          </p>
          <div className="w-24 h-1 bg-white/20 mx-auto mt-4 sm:mt-8" data-id="element-27"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-8 sm:mb-12" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-20px'
        }} transition={{
          duration: 0.2,
          delay: index * 0.05
        }} className="bg-green-950/60 p-6 rounded-2xl shadow-lg border-2 border-yellow-300/40 relative flex flex-col h-full" data-id="element-29">
              <div className="absolute -top-4 -right-4 bg-red-500 text-white font-bold px-3 py-1 rounded-full shadow-md transform rotate-3" data-id="element-30">
                BONO
              </div>
              <div className="text-4xl mb-4" data-id="element-31">{bonus.emoji}</div>
              <h3 className="text-lg font-bold text-white mb-3 leading-tight" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-white/70 text-sm mb-6 flex-grow" data-id="element-33">
                {bonus.desc}
              </p>
              <div className="mt-auto pt-4 border-t border-white/10" data-id="element-34">
                <div className="text-sm text-white/60 mb-1" data-id="element-35">
                  Valor: <span className="line-through" data-id="element-36">{bonus.value}</span>
                </div>
                <div className="text-xl font-black text-yellow-300 flex items-center gap-2" data-id="element-37">
                  HOY: GRATIS <CheckCircle2 className="w-5 h-5" data-id="element-38" />
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-green-950/60 p-8 rounded-2xl shadow-xl border border-green-600/25 text-center max-w-2xl mx-auto" data-id="element-39">
          <p className="text-lg text-white/80 font-medium mb-2" data-id="element-40">
            Valor total de los bonos:
          </p>
          <p className="text-3xl font-bold text-white/50 line-through mb-2" data-id="element-41">
            $25.970
          </p>
          <p className="text-xl font-medium text-white mb-4" data-id="element-42">
            Hoy te los llevás por:
          </p>
          <p className="text-6xl font-black text-yellow-300 mb-4" data-id="element-43">$0</p>
          <p className="text-lg font-bold text-yellow-300 flex items-center justify-center gap-2" data-id="element-44">
            Incluidos gratis con tu compra de hoy
          </p>
        </motion.div>
      </div>
    </section>;
}